import { render, staticRenderFns } from "./industryNews.vue?vue&type=template&id=9360e432&scoped=true"
import script from "./industryNews.vue?vue&type=script&lang=js"
export * from "./industryNews.vue?vue&type=script&lang=js"
import style0 from "./industryNews.vue?vue&type=style&index=0&id=9360e432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9360e432",
  null
  
)

export default component.exports